(function () {
  function getCards(slider) {
    var selector = slider.getAttribute('selector') || '.card';
    return Array.prototype.slice.call(slider.querySelectorAll(selector));
  }

  function getCurrentIndex(slider) {
    var cards = getCards(slider);
    if (!cards.length) return 0;

    var sliderRect = slider.getBoundingClientRect();
    var current = 0;
    var minDistance = Infinity;

    cards.forEach(function (card, index) {
      var distance = Math.abs(card.getBoundingClientRect().left - sliderRect.left);
      if (distance < minDistance) {
        minDistance = distance;
        current = index;
      }
    });

    return current;
  }

  function scrollToIndex(slider, index) {
    var cards = getCards(slider);
    if (!cards.length) return;

    var targetIndex = Math.max(0, Math.min(index, cards.length - 1));
    var target = cards[targetIndex];
    var left = target.offsetLeft - slider.offsetLeft;

    slider.scrollTo({
      left: left,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  }

  function setDots(slider, index) {
    var section = slider.closest('.V2MultSalePoint');
    if (!section) return;

    section.querySelectorAll('slider-dots[aria-controls="' + slider.id + '"] button').forEach(function (dot, dotIndex) {
      dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
    });
  }

  function setButtons(slider, index) {
    var section = slider.closest('.V2MultSalePoint');
    var cards = getCards(slider);
    if (!section || !cards.length) return;

    section.querySelectorAll('[aria-controls="' + slider.id + '"]').forEach(function (button) {
      var role = button.getAttribute('is');
      if (role === 'previous-button') {
        button.disabled = index <= 0;
      }
      if (role === 'next-button') {
        button.disabled = index >= cards.length - 1;
      }
    });
  }

  function syncSlider(slider) {
    var index = getCurrentIndex(slider);
    setDots(slider, index);
    setButtons(slider, index);
  }

  function initSlider(slider) {
    if (slider.dataset.v2MultSalePointReady === 'true') return;
    slider.dataset.v2MultSalePointReady = 'true';

    slider.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        syncSlider(slider);
      });
    }, { passive: true });

    syncSlider(slider);
  }

  function initDots(dots) {
    if (dots.dataset.v2MultSalePointReady === 'true') return;
    dots.dataset.v2MultSalePointReady = 'true';

    var slider = document.getElementById(dots.getAttribute('aria-controls'));
    if (!slider) return;

    dots.querySelectorAll('button').forEach(function (button, index) {
      button.addEventListener('click', function () {
        var dataIndex = parseInt(button.getAttribute('data-index'), 10);
        scrollToIndex(slider, Number.isNaN(dataIndex) ? index : dataIndex - 1);
      });
    });
  }

  function initButtons(scope) {
    scope.querySelectorAll('[is="previous-button"], [is="next-button"]').forEach(function (button) {
      if (button.dataset.v2MultSalePointReady === 'true') return;
      button.dataset.v2MultSalePointReady = 'true';

      button.addEventListener('click', function () {
        var slider = document.getElementById(button.getAttribute('aria-controls'));
        if (!slider) return;

        var direction = button.getAttribute('is') === 'previous-button' ? -1 : 1;
        scrollToIndex(slider, getCurrentIndex(slider) + direction);
      });
    });
  }

  function initVideo(videoMedia) {
    if (videoMedia.dataset.v2MultSalePointReady === 'true') return;
    videoMedia.dataset.v2MultSalePointReady = 'true';

    var template = videoMedia.querySelector('template');
    if (!template) return;

    var content = template.content ? template.content.cloneNode(true) : null;
    if (!content) return;

    videoMedia.appendChild(content);
    videoMedia.setAttribute('loaded', '');

    var video = videoMedia.querySelector('video');
    if (video && videoMedia.hasAttribute('autoplay')) {
      video.play().catch(function () {});
    }
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('.V2MultSalePoint slider-element').forEach(initSlider);
    scope.querySelectorAll('.V2MultSalePoint slider-dots').forEach(initDots);
    scope.querySelectorAll('.V2MultSalePoint video-media').forEach(initVideo);
    initButtons(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
